<template>
  <div class="file-upload">
    <div v-if="isMulti">
      <el-upload
        action="#"
        :drag="drag"
        :disabled="uploadDisabled"
        multiple
        :file-list="fileList"
        :on-success="onSuccess"
        list-type="picture-card"
        :http-request="fileUpLoad"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :before-upload="beforeAvatarUpload"
        :on-error="handleError"
      >
        <slot><i class="el-icon-plus"></i></slot>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </div>
    <div v-else>
      <!-- 单图上传后默认支持放大预览和删除，删除后可重新上传。 -->
      <template v-if="singlePreviewDelete">
        <div class="single-upload-wrap">
          <template v-if="singlePreviewUrl">
            <div class="avatar-uploader">
            <div class="single-upload-thumb avatar">
              <img
                class="single-upload-thumb__img"
                :src="singlePreviewUrl"
                alt=""
              />
              <div class="single-upload-thumb__mask">
                <div class="single-upload-thumb__actions">
                  <button
                    type="button"
                    class="single-upload-action"
                    title="预览"
                    aria-label="放大预览图片"
                    @click.stop="openSingleThumbPreview"
                  ><i class="el-icon-zoom-in" aria-hidden="true"></i></button>
                  <button
                    v-if="!uploadDisabled"
                    type="button"
                    class="single-upload-action"
                    title="删除"
                    aria-label="删除图片"
                    @click.stop="handleSingleRemove"
                  ><i class="el-icon-delete" aria-hidden="true"></i></button>
                </div>
              </div>
            </div>
            </div>
            <el-dialog
              title="预览"
              :visible.sync="singlePreviewDialogVisible"
              append-to-body
              width="720px"
              class="single-upload-preview-dialog"
            >
              <img class="single-upload-preview-dialog__img" :src="singlePreviewUrl" alt="" />
            </el-dialog>
          </template>
          <el-upload
            v-else
            class="avatar-uploader"
            action="#"
            :drag="drag"
            :disabled="uploadDisabled"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="onSuccess"
            :http-request="fileUpLoad"
            :on-error="handleError"
          >
            <slot><i class="el-icon-plus avatar-uploader-icon"></i></slot>
          </el-upload>
        </div>
      </template>
      <el-upload
        v-else
        class="avatar-uploader"
        action="#"
        :drag="drag"
        :disabled="uploadDisabled"
        :show-file-list="false"
        :before-upload="beforeAvatarUpload"
        :on-success="onSuccess"
        :http-request="fileUpLoad"
        :on-error="handleError"
      >
        <img v-if="imageUrl || url" :src="imageUrl || url" class="avatar" />
        <slot v-else><i class="el-icon-plus avatar-uploader-icon"></i></slot>
      </el-upload>
    </div>
  </div>
</template>

<script>
import { getAliOssSts } from '@/components/file-upload/api'
import ossClient, { getFilePath, getSystemPath } from './oss'
import { localget, localset } from '@/utils/localStorage'
import * as imageConversion from 'image-conversion'
import { Loading } from 'element-ui'
export default {
  name: 'FileUpload',
  // isMulti:是否上传多张；name：文件名，url：文件链接
  // 如果isMulti==true, name和url应该是个数组，否则为字符串
  // singlePreviewDelete：单图默认支持预览、删除；传 false 可使用原上传交互。
  inject: {
    elForm: {
      default: null,
    },
  },
  props: {
    isMulti: [Boolean, String],
    drag: {
      type: Boolean,
      default: true,
    },
    name: {},
    url: {},
    singlePreviewDelete: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // 单张图片的封面
      imageUrl: '',
      // 多张图片的封面
      fileList: [],
      // oss上传配置项
      uploadConf: {},
      // 多张图片预览dialog
      dialogImageUrl: '',
      dialogVisible: false,
      list: [],
      loading: null,
      /** 单图：用户点删除后，在父级仍可能残留 url 前不展示缩略图 */
      singleRemoved: false,
      singlePreviewDialogVisible: false,
    }
  },
  computed: {
    uploadDisabled() {
      return this.disabled || !!(this.elForm && this.elForm.disabled)
    },
    // 单图：展示与预览地址（上传完为完整 URL；父组件 url 传入完整地址亦可）
    singlePreviewUrl() {
      if (this.singlePreviewDelete && this.singleRemoved) {
        return ""
      }
      return this.imageUrl || this.url || ""
    },
  },
  watch: {
    name: {
      handler(val) {
        if (this.isMulti) {
          return
        }
        if (this.singlePreviewDelete && val) {
          this.singleRemoved = false
        }
      },
    },
    url: {
      handler(newV, oldV) {
        // 如果是多张图片
        if (this.isMulti) {
          if (newV) {
            // 当监视到url有新值时给fileList赋值初始值
            this.fileList = newV.map((item, index) => {
              const ossKey = Array.isArray(this.name) ? this.name[index] : undefined
              return {
                url: item,
                name: ossKey,
                ossKey,
              }
            })
            this.list = this.fileList
          }
        } else {
          this.imageUrl = newV
          if (this.singlePreviewDelete && newV) {
            this.singleRemoved = false
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.uploadConf = localget('alioss')
    if (!this.uploadConf || !this.uploadConf.domain) {
      getAliOssSts().then(res => {
        this.uploadConf = {
          region: 'oss-cn-hangzhou',
          accessKeyId: res.accessKeyId,
          accessKeySecret: res.accessKeySecret,
          bucket: res.bucket,
          stsToken: res.securityToken,
          domain: res.domain,
        }
        localset('alioss', this.uploadConf, 1800)
      })
    }
  },
  methods: {
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024
      return new Promise((resolve, reject) => {
        this.loading = Loading.service({
          lock: true, //是否锁定屏幕的滚动
          spinner: 'el-icon-loading',
          text: '上传中', //loading下面的文字
          background: 'rgba(0, 0, 0, 0.0)', //loading的背景色
          target: 'body' //loading显示在容器
        })
        if (isLt2M < 6) {
          // 小于6M不用压缩
          resolve(file)
        } else {
          //6140kb
          imageConversion.compressAccurately(file, 3072).then(res => {
            console.log('大于6M进行压缩', res)
            resolve(res)
          })
        }
      })
    },
    onSuccess(res, file, filelist) {
      if (this.loading) {
        this.loading.close()
      }
      if (this.isMulti) {
        this.fileList = filelist
        this.list = filelist
          .filter(item => (item.response && item.response.name) || item.ossKey)
          .map(item => {
            const name = (item.response && item.response.name) || item.ossKey
            return {
              url: item.response ? this.uploadConf.domain + "/" + name : item.url,
              name,
              ossKey: name,
              fileUid: item.uid,
            }
          })
        const nameList = this.getUploadedNames(filelist)
        this.$emit('fileUpload', this.list)
        this.$emit('update:name', nameList)
      } else {
        if (this.singlePreviewDelete) {
          this.singleRemoved = false
        }
        this.imageUrl = this.uploadConf.domain + "/" + res.name
        const uploadInfo =  {
          url: this.imageUrl,
          name: res.name,
          fileUid: file.uid
        }
        this.file = {
          ...uploadInfo
        }
        this.$emit('fileUpload', uploadInfo)
        this.$emit('update:name', this.file.name)
      }
    },
    handleError() {
      if (this.loading) {
        this.loading.close()
      }
    },
    //上传文件操作，调用阿里云
    fileUpLoad(option) {
      //提前拼接返回地址
      let filePath = getFilePath(this.$route.name, option.file.name)
      if (option.file.size > 6291456) {
        this.$message.error('资源文件大小超出范围')
        return
      }
      return ossClient(this.uploadConf).put(filePath, option.file)
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      this.list = this.fileList
      const nameList = this.getUploadedNames(this.list)
      this.$emit('update:name', nameList)
    },
    // 回显照片使用已有 OSS key，新照片仅使用上传成功后返回的 key。
    getUploadedNames(fileList) {
      return fileList
        .map(item => (item.response && item.response.name) || item.ossKey)
        .filter(Boolean)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    openSingleThumbPreview() {
      this.singlePreviewDialogVisible = true
    },
    handleSingleRemove() {
      if (this.uploadDisabled) return
      this.singlePreviewDialogVisible = false
      this.singleRemoved = true
      this.imageUrl = ""
      this.file = null
      this.$emit("update:name", "")
      this.$emit("update:url", "")
      this.$emit("fileUpload", null)
    },
  }
}
</script>

<style scoped lang="scss">
// 拖拽复用原上传入口，保持现有单图、多图上传框尺寸。
.file-upload /deep/ .el-upload-dragger {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: inherit;
  background: transparent;

  &.is-dragover {
    background: #ecf5ff;
    outline: 2px solid #409eff;
    outline-offset: -2px;
  }
}

.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader  /deep/ .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}

.avatar {
  width: 148px;
  height: 148px;
  display: block;
}

.single-upload-wrap {
  display: inline-block;
  vertical-align: top;
}

.single-upload-thumb {
  position: relative;
  width: 148px;
  height: 148px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #ebeef5;
  background: #f5f7fa;
}

.single-upload-thumb__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  vertical-align: top;
}

.single-upload-thumb__mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.single-upload-thumb:hover .single-upload-thumb__mask,
.single-upload-thumb:focus-within .single-upload-thumb__mask {
  opacity: 1;
}

.single-upload-thumb__actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
}

.single-upload-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.single-upload-thumb__actions i {
  font-size: 22px;
  color: #fff;
  cursor: pointer;
  line-height: 1;
}

.single-upload-thumb__actions i:hover {
  color: #ecf5ff;
}

.single-upload-preview-dialog__img {
  display: block;
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
}
</style>
